<template>
  <div id="app">
    <InspectionReport />
  </div>
</template>

<script setup>
import InspectionReport from './components/InspectionReport.vue';
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
